// Datos bancarios de Little Blue para pagos por TRANSFERENCIA / DEPÓSITO.
// ───────────────────────────────────────────────────────────────────────
// EDITAR ACÁ si cambian (requiere rebuild del front). A futuro: servir estos
// datos desde el backoffice (config editable) para no depender de un deploy.
export const BANK_TRANSFER = {
  cbu: "0110042620004200566539",
  alias: "LITTLE.NACION",
  cuit: "30-71050128-5",
  cuenta: "CC en Pesos 34800420056653",
};
